import React, { Fragment } from 'react';
import classNames from 'classnames';
import styles from './assets/seance-actions.module.scss';
import { numberWithCommas } from '../../../../../../helpers/format';
import { Link } from 'react-router-dom';
import Router from '../../../../../../navigation/router';
import { routes } from '../../../../../../navigation';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';

interface Props {
    logs: any;
}

const AmountLogs: React.FunctionComponent<Props> = ({ logs }: Props) => (
    <Fragment>
        {logs.map((it: any) => (
            <div className={classNames(styles.log)} style={{ display: 'flex' }}>
                <div className={'mr-1'}>${numberWithCommas(it.amount)}</div>
                <Link className={'mr-1'} to={Router.generate(routes.PAYMENT_DETAIL, { id: it.payment.id })}>
                    <small>payment ID: {it.payment.id}</small>
                </Link>
                <small className={'mr-1'}>
                    {it.applianceDate ? `${changeToZeroMoment(it.applianceDate, 'MMM D, YYYY')}` : ''}
                </small>
                <small>{it.paymentCredit ? 'from Credit' : ''}</small>
            </div>
        ))}
    </Fragment>
);
export default AmountLogs;
